import React from "react";
import { Button } from "antd";
import useIntercom from "@/hooks/useIntercom";

function PremiumContactUs() {
  const { newMessage } = useIntercom();
  return (
    <Button
      onClick={() =>
        newMessage(
          "Hey 👋 \n\nI’m interested in learning more about the premium feature I was just checking out: [add premium feature]. Could you please share more details? Thanks!"
        )
      }
      type={"primary"}
    >
      Contact us
    </Button>
  );
}

export default PremiumContactUs;
